export type SarvamCallingWindowSettings = {
  startMinutes?: number;
  endMinutesExclusive?: number;
  startTime?: string;
  endTime?: string;
  startHour?: number;
  endHour?: number;
};

const MINUTES_PER_DAY = 24 * 60;

export function defaultSarvamCallingWindowTimes(): { startTime: string; endTime: string } {
  return { startTime: '00:00', endTime: '23:59' };
}

export function callingWindowTimesFromSettings(
  cw: SarvamCallingWindowSettings | undefined | null
): { startTime: string; endTime: string } {
  if (!cw) return defaultSarvamCallingWindowTimes();
  if (cw.startTime && cw.endTime) {
    return { startTime: cw.startTime, endTime: cw.endTime };
  }
  if (cw.startMinutes != null && cw.endMinutesExclusive != null) {
    return {
      startTime: minutesToTimeInput(cw.startMinutes),
      endTime: exclusiveEndToInclusiveTimeInput(cw.endMinutesExclusive),
    };
  }
  if (cw.startHour != null || cw.endHour != null) {
    const startMinutes = Math.round((cw.startHour ?? 0) * 60);
    const endExclusive = Math.round((cw.endHour ?? 24) * 60);
    return {
      startTime: minutesToTimeInput(startMinutes),
      endTime: exclusiveEndToInclusiveTimeInput(endExclusive),
    };
  }
  return defaultSarvamCallingWindowTimes();
}

function minutesToTimeInput(minutes: number): string {
  const m = Math.max(0, Math.min(MINUTES_PER_DAY - 1, Math.round(minutes)));
  const h = Math.floor(m / 60);
  const min = m % 60;
  return `${String(h).padStart(2, '0')}:${String(min).padStart(2, '0')}`;
}

function exclusiveEndToInclusiveTimeInput(endExclusive: number): string {
  if (endExclusive >= MINUTES_PER_DAY) return '23:59';
  return minutesToTimeInput(endExclusive - 1);
}
